// extracted by mini-css-extract-plugin
export default {"rate":"CreateEditTaxModal_rate__Ho4Tn"};